/* Custom Drops - header scroll state.
   Adds .cd-scrolled to <body> once you've left the hero, which is what
   the darker blurred bar and the gradient hairline key off. Throttled
   with rAF so it costs nothing on scroll. */
(function () {
  var THRESHOLD = 60;
  var ticking = false;

  function update() {
    var on = window.scrollY > THRESHOLD;
    document.body.classList.toggle('cd-scrolled', on);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
